import apple from './apple.svg';
import arrowDown from './arrow-down.svg';
import arrowUp from './arrow-up.svg';
import avatar from './avatars/avatar.png';
import ceo from './avatars/ceo.png';
import cfo from './avatars/cfo.png';
import coo from './avatars/coo.png';
import sd from './avatars/sd.png';
import battery from './battery.svg';
import bocconi from './bocconi.png';
import bomOverview from './bom-overview.png';
import bottleCustomised from './bottle-customised.svg';
import bottlePremium from './bottle-premium.svg';
import bottleStandard from './bottle-standard.svg';
import built from './built.png';
import businessplanEris from './businessplan-eris.svg';
import balancesheetActive from './businessplanMenu/balancesheet-active.svg';
import balancesheet from './businessplanMenu/balancesheet.svg';
import cashflowActive from './businessplanMenu/cashflow-active.svg';
import cashflow from './businessplanMenu/cashflow.svg';
import businessplancheck from './businessplanMenu/check.svg';
import businessplandownload from './businessplanMenu/download.svg';
import exportreportsActive from './businessplanMenu/exportreports-active.svg';
import exportreports from './businessplanMenu/exportreports.svg';
import incomeActive from './businessplanMenu/income-active.svg';
import income from './businessplanMenu/income.svg';
import procurementActive from './businessplanMenu/procurement-active.svg';
import procurement from './businessplanMenu/procurement.svg';
import productionActive from './businessplanMenu/production-active.svg';
import production from './businessplanMenu/production.svg';
import salesActive from './businessplanMenu/sales-active.svg';
import sales from './businessplanMenu/sales.svg';
import check from './check.svg';
import chemical from './chemical.svg';
import closeMailPopUp from './close.svg';
import commentHover from './comment-hover.svg';
import comment from './comment.svg';
import designmethod from './designmethod.svg';
import doc from './doc.svg';
import docdocument from './docdocument.svg';
import downloadHover from './download-hover.svg';
import download from './download.svg';
import editHover from './edit-hover.svg';
import edit from './edit.svg';
import erisPoint from './eris-point.svg';
import eris from './eris.png';
import exportIconHover from './export-hover.svg';
import exportIcon from './export.svg';
import folder from './folder.svg';
import folderResults from './folderResults.svg';
import gamesColor from './games-color.svg';
import games from './games.svg';
import glassBottle from './glass-bottle.svg';
import heartOrange from './heart-orange.svg';
import heart from './heart.svg';
import inbox from './inbox.svg';
import leftArrowTemp from './left-arrow-temp.svg';
import lock from './lock.svg';
import logoAreaHeader from './logo-area-admin-header.png';
import logoAreaWhite from './logo-area-white.png';
import logoArea from './logo-area.png';
import logout from './logout.svg';
import manzanita from './manzanita.png';
import mellino from './mellino.png';
import money from './money.svg';
import nextArrow from './next-arrow.svg';
import pdfdocument from './pdfdocument.svg';
import plusDark from './plus-dark.svg';
import plus from './plus.svg';
import recycle from './recycle.svg';
import repeatHover from './repeat-hover.svg';
import repeat from './repeat.svg';
import results from './results.svg';
import reviewEye from './review_ico.svg';
import search from './search.svg';
import sessionsColor from './sessions-color.svg';
import sessions from './sessions.svg';
import sign from './sign.jpg';
import starEmpty from './star-empty.svg';
import starFull from './star-full.svg';
import statisticsHover from './statistics-hover.svg';
import statistics from './statistics.svg';
import submission from './submission.svg';
import tafaha from './tafaha.png';
import taste from './taste.svg';
import trash from './trash.svg';
import upload from './upload.svg';
import usersColor from './users-color.svg';
import users from './users.svg';
import viewHover from './view-hover.svg';
import view from './view.svg';
import volume from './volume.svg';
import wifi from './wifi.svg';
import wrench from './wrench.svg';
import xlsxdocument from './xlsxdocument.svg';
import xlsxDownload from './xlsxDownload.svg';













export default {
	wifi,
	volume,
	battery,
	heart,
	heartOrange,
	money,
	inbox,
	results,
	folder,
	folderResults,
	xlsxdocument,
	xlsxDownload,
	doc,
	designmethod,
	eris,
	erisPoint,
	built,
	bocconi,
	docdocument,
	pdfdocument,
	businessplanEris,

	avatar,
	ceo,
	coo,
	cfo,
	sd,

	sessions,
	sessionsColor,
	games,
	gamesColor,
	users,
	usersColor,
	plus,
	check,

	businessplandownload,
	businessplancheck,
	sales,
	salesActive,
	production,
	productionActive,
	procurement,
	procurementActive,
	income,
	incomeActive,
	balancesheet,
	balancesheetActive,
	cashflow,
	cashflowActive,
	exportreports,
	exportreportsActive,

	submission,

	starFull,
	starEmpty,

	bottleCustomised,
	bottlePremium,
	bottleStandard,
	nextArrow,
	closeMailPopUp,

	chemical,
	recycle,
	taste,
	wrench,

	bomOverview,
	glassBottle,
	apple,

	manzanita,
	mellino,
	tafaha,

	sign,
	logout,

	reviewEye,

	view,
	viewHover,
	exportIcon,
	exportIconHover,
	trash,
	lock,
	edit,
	editHover,
	statistics,
	statisticsHover,
	repeat,
	repeatHover,
	download,
	downloadHover,
	comment,
	commentHover,
	arrowDown,
	arrowUp,
	search,
	upload,
	plusDark,
	leftArrowTemp,
	logoArea,
	logoAreaWhite,

	logoAreaHeader
};
